<div class="container">
  <div class="cards">
    <a class="card" [routerLink]="['/subventions/search']">
      <div class="image">
        <mat-icon>search</mat-icon>
        <p>Buscador de subvenciones</p>
      </div>
      <div class="divider"></div>
      <div class="content">
        <p>Busca, encuentra y consigue todas las subvenciones que puedes obtener</p>
        <a [routerLink]="['/subventions/search']">Navegar</a>
      </div>
    </a>
    <a class="card" [routerLink]="['/subventions/alerts']">
      <div class="image">
        <mat-icon>notifications</mat-icon>
        <p>Alertas</p>
      </div>
      <div class="divider"></div>
      <div class="content">
        <p>Recibe tus subvenciones favoritas en tu email</p>
        <a [routerLink]="['/subventions/alerts']">Navegar</a>
      </div>
    </a>
    <a class="card" [routerLink]="['/subventions/favorites']">
      <div class="image">
        <mat-icon>favorite</mat-icon>
        <p>Subvenciones favoritas</p>
      </div>
      <div class="divider"></div>
      <div class="content">
        <p>Accede a los listados de subvenciones favoritas</p>
        <a [routerLink]="['/subventions/favorites']">Navegar</a>
      </div>
    </a>
  </div>
</div>
